import * as React from "react";
const SvgMicrosoftWord = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7AC6FF",
  d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v2H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C91FF",
  d: "M4 12h16v5H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4BABFF",
  d: "M4 7h16v5H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#137FE3",
  d: "M4 17h16v2a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A63B6",
  d: "M2.833 7h8.334c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H2.833A.833.833 0 0 1 2 16.167V7.833c0-.46.373-.833.833-.833"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.243 13.54q.028.214.036.373H5.3q.012-.15.05-.364.04-.213.07-.36l.97-4.187h1.255l1.007 4.124q.087.385.125.778h.017q.027-.381.104-.755L9.701 9h1.142l-1.41 6H8.098l-.956-3.973a9 9 0 0 1-.159-.85h-.017a9 9 0 0 1-.064.434 11 11 0 0 1-.078.427L5.925 15H4.568L3.15 9.002h1.163l.874 4.195q.03.13.056.343"
}));
export default SvgMicrosoftWord;
//# sourceMappingURL=MicrosoftWord.js.map